module.exports = __webpack_public_path__ + "9406bddae561fe912687f23c75d750c0.png";